import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

export default function AdminProtectedRoute({ children }) {
  const { admin } = useAdminAuth();
  const location = useLocation();

  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-gray-400 text-sm" data-testid="admin-auth-loading">
        Checking admin session…
      </div>
    );
  }
  if (admin === false) {
    return <Navigate to="/admin/login" state={{ from: location.pathname + location.search }} replace />;
  }
  return children;
}
